<template>
  <div>
    <template v-if="disabled">
      {{ data }}
    </template>
    <a-date-picker
      v-else
      format="YYYY"
      mode="year"
      :value="data"
      :open="yearOpen"
      @openChange="openChangeByYear"
      @panelChange="panelChangeByYear"
    />
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: undefined,
      yearOpen: false,
    }
  },
  watch: {
    data: {
      deep: true,
      handler(e) {
        this.$emit('input', e)
      },
    },
    value: {
      handler(e) {
        this.data = e
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    openChangeByYear(status) {
      if (status) {
        this.yearOpen = true;
      } else {
        this.yearOpen = false;
      }
    },
    panelChangeByYear(value) {
      this.data = moment(value).format('YYYY');
      this.yearOpen = false;
    },
  },
}

</script>

<style lang='scss'>
@import '@core/scss/vue/libs/vue-flatpicker.scss';

</style>
